import { buildCommonTransfer } from "@/components/excel/schema/label/transfer/base";
import {
  DayOption,
  MonthOption,
  YearOption,
} from "@/components/excel/schema/label/type/date";

export const DateValueTransfer = {
  ...buildCommonTransfer(YearOption),
  ...buildCommonTransfer(MonthOption),
  ...buildCommonTransfer(DayOption),
};
